import React, { Fragment } from 'react'
import styled from 'styled-components'
import AndIcon from 'src/images/svg/ampersand.svg'
import AndIconWhite from 'src/images/svg/ampersand-white.svg'
import shim from 'string.prototype.matchall/shim'

shim()

interface IAdjustedAmpProps {
  width: number
  marginLeft: number
  marginRight: number
  marginBottom: number
}

const AmpContainer = styled.span<IAdjustedAmpProps>`
  display: inline-block;
  vertical-align: baseline;
  position: relative;
  width: ${(props) => props.width.toFixed(4)}em;
  height: ${(props) => (props.width * (226 / 196)).toFixed(4)}em;
  margin-bottom: ${(props) => props.marginBottom.toFixed(4)}em;
  margin-left: ${(props) => props.marginLeft.toFixed(4)}em;
  margin-right: ${(props) => props.marginRight.toFixed(4)}em;
`

const AmpImageDefault = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity 0.5s ease-out;
  opacity: 1;

  .group:hover & {
    opacity: 0;
  }
`

const AmpImageHover = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity 0.5s ease-out;
  opacity: 0;

  .group:hover & {
    opacity: 1;
  }
`

const HORIZONTAL_MARGIN = 0.1

const getMargin = (neighbourCharacter: string): number =>
  neighbourCharacter.trim() === '' ? 0 : HORIZONTAL_MARGIN

const getLeftMargin = (previousToken?: string[]): number =>
  previousToken ? getMargin(previousToken[0].slice(-1)) : 0

const getRightMargin = (nextToken?: string[]): number =>
  nextToken ? getMargin(nextToken[0].charAt(0)) : 0

const getAmpIcon = (
  index: number,
  ampersandScale: number,
  previousToken?: string[],
  nextToken?: string[],
  customMargin?: number
): JSX.Element => (
  <AmpContainer
    key={`${index}`}
    width={ampersandScale * 0.7}
    marginBottom={0.3 * (1 - ampersandScale) - 0.05}
    marginLeft={customMargin !== undefined ? customMargin : getLeftMargin(previousToken)}
    marginRight={customMargin !== undefined ? customMargin : getRightMargin(nextToken)}
  >
    <AmpImageDefault src={AndIcon} alt="and" />
    <AmpImageHover src={AndIconWhite} alt="and" />
  </AmpContainer>
)

const emphasizeAmpersand = (
  text?: string,
  ampersandScale: number = 1,
  customMargin?: number
): JSX.Element[] | null => {
  if (!text) {
    return null
  }

  const strToMatch = customMargin !== undefined ? text.replace(/\s*&\s*/g, '&') : text

  return Array.from(strToMatch.matchAll(/&|[^&]+/g)).map(([token], index, arr) =>
    token === '&' ? (
      getAmpIcon(index, ampersandScale, arr[index - 1], arr[index + 1], customMargin)
    ) : (
      // eslint-disable-next-line react/no-array-index-key
      <Fragment key={`${index}`}>{token}</Fragment>
    )
  )
}

export default emphasizeAmpersand
